import { render, staticRenderFns } from "./transfer-funds.vue?vue&type=template&id=1cc55ed8&scoped=true&"
import script from "./transfer-funds.vue?vue&type=script&lang=js&"
export * from "./transfer-funds.vue?vue&type=script&lang=js&"
import style0 from "./transfer-funds.vue?vue&type=style&index=0&id=1cc55ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc55ed8",
  null
  
)

export default component.exports